// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

export {
	getElementTop,
	isElementInViewport,
	getScrollableParent,
	scrollElementToViewCenter,
	getElementBounds,
	isTopOfElementStillInViewPort,
	isPartOfElementStillInViewPort,
	replaceDomElementContent,
} from './dom';
export {
	removeJquery,
	parseScriptTags,
	deferScript,
	convertScriptTagsToPreloadTags,
	convertSuperBatchResourceToScriptTags,
} from './script';
export { useWindowSize } from './useWindowSize';
export const GLOBALLY_DEFINED_MACRO_RESOURCES_CONTAINER = 'confluence-macro-resources-container';
